const composeInitialSort = (initialSort) => {
  const descending = /^d/.test(initialSort);

  return {
    field: initialSort.replace(/^(d)?(meta)?/, ''),
    direction: descending ? 'descending' : 'ascending',
  };
};

export default composeInitialSort;
